import {
  LIST_BULK_PROCESS_REQUEST,
  LIST_BULK_PROCESS_SUCCESS,
  LIST_BULK_PROCESS_FAIL,
  CREATE_BULK_PROCESS_REQUEST,
  CREATE_BULK_PROCESS_SUCCESS,
  CREATE_BULK_PROCESS_FAIL,
  GET_BULK_PROCESS_REQUEST,
  GET_BULK_PROCESS_SUCCESS,
  GET_BULK_PROCESS_FAIL,
  DETAIL_LIST_BULK_PROCESS_REQUEST,
  DETAIL_LIST_BULK_PROCESS_SUCCESS,
  DETAIL_LIST_BULK_PROCESS_FAIL,
  EXPORT_DETAIL_BULK_PROCESS_REQUEST,
  EXPORT_DETAIL_BULK_PROCESS_SUCCESS,
  EXPORT_DETAIL_BULK_PROCESS_FAIL
} from '../../constants/bulk-process'

const initialState = {
  loading: false,
  bulkProcess: [],
  error: null,
  detailBulkProcess: [],
  loadingListDetail: false,
  loadingDetail: false,
  loadingExport: false
}

const bulkProcessReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_BULK_PROCESS_REQUEST:
      return {
        ...state,
        loading: true,
        bulkProcess: []
      }
    case LIST_BULK_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        bulkProcess: action.payload,
        pageable: action.pageable
      }
    case LIST_BULK_PROCESS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        bulkProcess: action?.dummy
      }
    case CREATE_BULK_PROCESS_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_BULK_PROCESS_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_BULK_PROCESS_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case GET_BULK_PROCESS_REQUEST: {
      return {
        ...state,
        loadingDetail: true
      }
    }
    case GET_BULK_PROCESS_SUCCESS: {
      return {
        ...state,
        loadingDetail: false,
        bulkProces: action.payload,
        error: null
      }
    }
    case GET_BULK_PROCESS_FAIL: {
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        bulkProces: action?.dummy
      }
    }
    case DETAIL_LIST_BULK_PROCESS_REQUEST: {
      return {
        ...state,
        loadingListDetail: true
      }
    }
    case DETAIL_LIST_BULK_PROCESS_SUCCESS: {
      return {
        ...state,
        loadingListDetail: false,
        detailBulkProcess: action.payload,
        pageable: action.pageable,
        error: null
      }
    }
    case DETAIL_LIST_BULK_PROCESS_FAIL: {
      return {
        ...state,
        loadingListDetail: false,
        error: action.payload,
        detailBulkProcess: action?.dummy
      }
    }
    case EXPORT_DETAIL_BULK_PROCESS_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_DETAIL_BULK_PROCESS_SUCCESS:
      return {
        ...state,
        loadingExport: false
      }
    case EXPORT_DETAIL_BULK_PROCESS_FAIL:
      return {
        ...state,
        loadingExport: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default bulkProcessReducer
